module.exports = __webpack_public_path__ + "static/media/KMH_5135.9354ae48.jpg";